import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Thermometer.css';

/**
 * Affiche une mesure de température accompagnée d'une icône.
 * @param {object} props
 * @param {number | string | null} [props.value]
 */
export default function Thermometer( props ) {
	return( 
		<React.Fragment>
			<div className={`thermometer-root`}>
				<FontAwesomeIcon icon={['fas', 'thermometer-half']} className="display-4 mx-2" /> {`${( props.value ) ? props.value : ""}`}
			</div>
		</React.Fragment>
	);
}
